import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useCallback, useState } from 'react';
import { Message } from '../../primitives/internal/Message/index.js';
import { Container } from '../../primitives/TextInput/components/Container.js';
import { Label } from '../../primitives/TextInput/components/Label.js';
import { Textarea } from '../../primitives/TextInput/components/Textarea.js';
import { Wrapper } from '../../primitives/TextInput/components/Wrapper.js';
export const Area = /*#__PURE__*/_styled(forwardRef(function Area({
  disabled,
  visuallyFocused,
  label,
  name,
  value,
  className,
  placeholder = ' ',
  message,
  onFocus,
  onBlur,
  ...restProps
}, ref) {
  const [focused, setFocused] = useState(false);
  const handleFocus = useCallback(event => {
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  }, [onFocus]);
  const handleBlur = useCallback(event => {
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  }, [onBlur]);
  return _jsxs(Wrapper, {
    ref: ref,
    children: [_jsxs(Container, {
      className: className,
      focused: focused || !!visuallyFocused,
      disabled: disabled,
      children: [_jsx(Textarea, {
        ...restProps,
        disabled: disabled,
        name: name,
        placeholder: placeholder,
        value: value,
        onFocus: handleFocus,
        onBlur: handleBlur
      }), placeholder === ' ' && _jsx(Label, {
        tabIndex: -1,
        "data-testid": "label",
        disabled: disabled,
        children: label
      })]
    }), message && _jsx(Message, {
      "data-testid": "message",
      children: message
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1vdsy1t0"
} : {
  target: "e1vdsy1t0",
  label: "Area"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");